<template>
  <CSidebar
    id="sidebar"
    unfoldable
    :minimize="minimize"
    :show="show"
    dropdown-mode="openActive"
    color-scheme="light"
    @update:show="value => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="c-sidebar-brand-full my-3"
        name="peLogo"
        size="custom-size"
        :height="55"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="peIcon"
        size="custom-size"
        :height="40"
      />
    </CSidebarBrand>
    <div class="sidebar-content">
      <TheSidebarNav />
    </div>
  </CSidebar>
</template>

<script>
/**
 * TheSidebar
 *
 * Root sidebar component.
 * Supports responsive design.
 */
import { mapState } from 'vuex'

import TheSidebarNav from './TheSidebarNav'

export default {
  name: 'TheSidebar',
  components: {
    TheSidebarNav
  },
  computed: mapState({
    show: state => state.root.sidebarShow,
    minimize: state => state.root.sidebarMinimize
  }),
  methods: {
    /**
     * Clears search value input and results.
     */
    clear () {
      this.searchValue = ''
      this.searchResults = []
    },
    /**
     * onSelect handler for navigation search
     * results link click.
     *
     * @param {String} value - company/property name
     */
    handleSelect (value) {
      this.clear()
    }
  }
}
</script>

<style lang="scss" scoped>
#sidebar {
  // Override elevation set in @coreui/coreui-pro/scss/_sidebar.scss
  // (it creates a visible line separating sidebar brand and the header)
  box-shadow: none;

  .c-sidebar-brand {
    border-bottom: 1px solid $gray-200;
  }
  .sidebar-content {
    height: 100%;
    box-shadow: 0 2px 2px 0 rgba(60, 75, 100, .14), 0 3px 1px -2px rgba(60, 75, 100, .12), 0 1px 5px 0 rgba(60, 75, 100, .20);
  }
}
</style>
